import {RegistrationModel} from 'models/registration/RegistrationModel'
import {StepConfig, StepKey, StepModel} from 'models/registration/StepModel'
import {LinkType, WysiwygType} from 'types'
import {Memoize} from 'util/memoize'
import {ConfirmationOption} from 'views/registration/steps/summarystep'

export type SummaryStepConfig = StepConfig & {
	no_pricing: boolean
	thanks_link: LinkType
	terms_and_conditions: WysiwygType
	privacy_policy: WysiwygType
	no_show: WysiwygType
	paypal: WysiwygType
	methods_label?: string
	methods?: Array<{
		label: string
		key: string
	}>
}

export type SummaryStepState = {
	payment_option?: string
	agree_terms?: boolean
	agree_privacy?: boolean
	agree_no_show?: boolean
}

export type ConfirmationData = {
	options: Array<ConfirmationOption>
	token: string
	payment: {
		order_data: Record<string, string>
		ogone_post_url: string
		order_id: string
	}
	price: {
		excl: number
		vat: number
		incl: number
	}
	confirmed: boolean
}

export class SummaryStepModel extends StepModel<SummaryStepConfig> {
	@Memoize()
	get key(): StepKey {
		return 'summary'
	}

	@Memoize()
	get state(): SummaryStepState {
		return this.registration.state.summary
	}

	@Memoize()
	get methodsLabel(): string {
		return this.config.methods_label || ''
	}

	@Memoize()
	get methods() {
		return this.config.methods || []
	}

	@Memoize()
	get shouldShowPricing(): boolean {
		return !this.config.no_pricing
	}

	@Memoize()
	get isApplicable(): boolean {
		return true
	}

	@Memoize()
	get isReady(): boolean {
		if (!this.state.agree_terms) return false
		if (!this.state.agree_privacy) return false
		if (
			this.registration.isInvitee &&
			!this.registration.isOnsite &&
			!this.state.agree_no_show
		)
			return false
		if (this.registration.isOnsite && !this.registration.confirmation)
			return false
		return true
	}

	@Memoize()
	get thanksUrl(): string {
		if (!this.config.thanks_link) return '/'
		return this.config.thanks_link.url
	}

	@Memoize()
	get shouldShowNoShow(): boolean {
		return (
			this.registration.isInvitee &&
			this.event.state.no_show &&
			!!this.config.no_show
		)
	}

	// ----- State changes ----- //
	setConfirmation(confirmation: ConfirmationData): RegistrationModel {
		return this.registration.update({confirmation})
	}

	setState(newState: SummaryStepState): RegistrationModel {
		return this.registration.update({
			summary: {...this.state, ...newState}
		})
	}
}
